import "../styles/components/Loading.css";

const Loading = ({ fullScreen = true, message = "Loading" }) => {
  return (
    <div
      className={`benoma-loading d-flex align-items-center justify-content-center text-light ${
        fullScreen ? "benoma-loading-fullscreen" : "py-5"
      }`}
      role="status"
      aria-live="polite"
    >
      <div className="text-center px-4">
        {/* Brand */}
        {fullScreen && (
          <div className="d-flex align-items-center justify-content-center gap-2 mb-4">
            <span className="loading-logo d-inline-flex align-items-center justify-content-center bg-danger text-white fw-bold">
              B
            </span>
            <span className="fs-4 fw-bold">Benoma</span>
          </div>
        )}
        {/* Loading indicator */}
        <div className="loading-indicator d-flex align-items-center justify-content-center gap-2 mb-3">
          <span />
          <span />
          <span />
        </div>
        {/* Status */}
        <small className="loading-status font-monospace text-secondary">
          <span className="text-danger">›</span> {message}
          <span className="loading-dots" aria-hidden="true">
            ...
          </span>
        </small>
        <span className="visually-hidden">{message}...</span>
      </div>
    </div>
  );
};

export default Loading;
